import _ from 'lodash'

/**
 * @var {ApiMiddleware}
 */
let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setProjectTypeApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        projectTypes: [],
    },
    getters: {
        projectTypes: state => state.projectTypes,
        projectTypeById: state => id => _.find(state.projectTypes, { id: id }),
    },
    mutations: {
        setProjectTypes: (state, projectTypes) => {
            state.projectTypes = projectTypes
        },
        addProjectType: (state, newProjectType) => {
            state.projectTypes.push(newProjectType)
        },
    },
    actions: {
        async projectTypesLoad({ commit }) {
            return api.get('/projectType?depth=2')
                .then(data => {
                    commit('setProjectTypes', data)
                    return data
                })
        },
        async updateProjectType(_, data) {
            return api.put(`/projectType/${data.id}`, data)
        },
        async createProjectType(_, data) {
            return api.post('/projectType', data)
        },
    },
})
